import { useEffect } from 'react'
import { createPortal } from 'react-dom'

import { FullPageSpinner } from './FullPage'

export const FullPageSpinnerPortal = () => {
  useEffect(() => {
    document.body.style.overflow = 'hidden'

    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [])

  return createPortal(<FullPageSpinner />, document.body)
}
